import { Component, Input, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import * as debug from 'debug';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { ToolsProvider } from '../../providers/tools/tools';
import { ConfigProvider } from '../../providers/config/config';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'tag-feed-menu',
  templateUrl: 'tag-feed-menu.html',
})
export class TagFeedMenuComponent {
  log = debug('app:TagFeedMenuComponent');

  @ViewChild('component') TagFeedMenuComponent;

  tags = [];
  @Input() hashtagSliderView = false;
  @Input() minimized = false;
  subs = [];

  constructor(
    public crudApi: CrudApiProvider,
    public tools: ToolsProvider,
    public configs: ConfigProvider
  ) {
    this.tags = this.filterToFeatured(this.configs.get('hashtags'));
    this.subs.push(
      this.configs.on('hashtagsUpdated', (hashtags) => {
        this.tags = this.filterToFeatured(hashtags);
        this.log('hashtags | toggle', this.tags);
      })
    );
  }

  ngOnDestroy() {
    _.each(this.subs, (s) => {
      if (s instanceof Function) {
        s();
      } else if (s.unsubscribe) {
        s.unsubscribe();
      }
    });
  }

  filterToFeatured(hashtags) {
    const selectedNonFeatured = _.filter(
      _.filter(hashtags, (h) => !_.get(h, 'states.isFeatured')),
      'selected'
    );
    return _.uniq(
      _.union(
        selectedNonFeatured,
        _.filter(hashtags, (h) => h.states.isFeatured || this.tools.isWeb)
      )
    );
  }

  ngOnChanges() {
    this.tags = this.filterToFeatured(this.configs.get('hashtags'));
    this.log('hashtags | changes', this.tags);
  }

  resetSelected() {
    this.tools.emit('resetSelected');
  }

  toggleTagsModal() {
    this.tools.emit('toggleTagsModal');
  }

  toggleTag(tag) {
    this.tools.emit('toggleTag', tag);
  }
}



// WEBPACK FOOTER //
// ./src/components/tag-feed-menu/tag-feed-menu.ts